import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { Col, Row } from "antd";

import { getRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { t } from "i18next";

import { authUserData } from "../../utils/Helper";

import Psuccess from "../../image/psuccess.png";
function PaymentSuccessWallet() {
  const navigate = useNavigate();
  const userId = authUserData()?.user_id;
  const CompanyId = authUserData()?.company ? authUserData()?.company : "";

  const [searchParams, setSearchParams] = useSearchParams();
  // useEffect(() => {
  //   const hasReloaded = sessionStorage.getItem("hasReloaded");

  //   if (!hasReloaded) {
  //     sessionStorage.setItem("hasReloaded", "true");
  //     window.location.reload();
  //   }
  // }, []);

  // Optional: Clear the reload flag when leaving the component
  // useEffect(() => {
  //   return () => {
  //     sessionStorage.removeItem("hasReloaded");
  //   };
  // }, []);

  useEffect(() => {
    const shouldReload = searchParams.get("reloaded");

    if (!shouldReload) {
      // Add a flag to URL to prevent infinite reloads
      searchParams.set("reloaded", "1");
      setSearchParams(searchParams);
      window.location.replace(window.location.href);
    }
  }, []);
  useEffect(() => {
    window.dispatchEvent(new Event("resize"));
  }, []);

  useEffect(() => {
    const userGetById = async () => {
      if (userId !== null) {
        try {
          const response = await getRequest(`user-detail/${userId}/`);
          console.log("response", response.data.data);
          if (response.data.success) {
            if (response.data.data) {
              localStorage.setItem(
                "auth_data",
                JSON.stringify(response?.data?.data)
              );
            }
          }
        } catch (error) {
          console.error("Error fetching user details:", error);
        } finally {
          // Set loading state to false after fetching data
        }
      }
    };
    if (CompanyId) {
      userGetById();
    }
  }, [userId]);

  const handleGetStarted = () => {
    CompanyId ? navigate("/my-wallet") : navigate("/transaction-list");
  };
  return (
    <>
      <div className="layout-content" style={{ height: "100%" }}>
        <Row gutter={[24, 0]} style={{ height: "100%" }}>
          {/* Wallet list */}
          <Col xs={24} className="mb-24">
            <section className="grid-sec" style={{ height: "100%" }}>
              <div className="ListingTopBar">
                <div className="pagenamewrap">
                  <div className="pagename">
                    <h3>{t("Payment")}</h3>
                  </div>
                </div>
              </div>

              <div className="paysucwallet">
                <div className="paysucwallinr">
                  <div className="imageverify">
                    <img src={Psuccess} alt=""></img>
                  </div>
                  <div className="pagename">
                    <h4>{t("Congratulations!, Payment Success")}</h4>
                  </div>
                  <ButtonField
                    className="BlueShadowBtn"
                    type="primary"
                    htmlType="button"
                    // onClick={() => navigate("/purchased-concierge-service")}
                    onClick={handleGetStarted}
                    label={t("Done")}
                  />
                </div>
              </div>
            </section>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default PaymentSuccessWallet;
